module.exports = __webpack_public_path__ + "static/media/st.1f545eb9.svg";